/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeDocumentsRequestItem
 */
export interface MergeDocumentsRequestItem {
    /**
     * 
     * @type {string}
     * @memberof MergeDocumentsRequestItem
     */
    documentId: string;
    /**
     * 
     * @type {number}
     * @memberof MergeDocumentsRequestItem
     */
    rotationDegrees: number;
}

/**
 * Check if a given object implements the MergeDocumentsRequestItem interface.
 */
export function instanceOfMergeDocumentsRequestItem(value: object): value is MergeDocumentsRequestItem {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('rotationDegrees' in value) || value['rotationDegrees'] === undefined) return false;
    return true;
}

export function MergeDocumentsRequestItemFromJSON(json: any): MergeDocumentsRequestItem {
    return MergeDocumentsRequestItemFromJSONTyped(json, false);
}

export function MergeDocumentsRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeDocumentsRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'rotationDegrees': json['rotationDegrees'],
    };
}

export function MergeDocumentsRequestItemToJSON(json: any): MergeDocumentsRequestItem {
    return MergeDocumentsRequestItemToJSONTyped(json, false);
}

export function MergeDocumentsRequestItemToJSONTyped(value?: MergeDocumentsRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'rotationDegrees': value['rotationDegrees'],
    };
}

